import React from "react";
import { IBlock } from "../../../../../types/IBlock";
import { redirect } from "../../../../../helpers/redirect";

import "./styles.scss";
import BlockCard from "../../../../BlockCard";
import { PanelWrapper } from "../../../../PanelWrapper";

interface IPullOutBlocksPanelLiteProps {
  blocks: IBlock[];
}

export const PullOutBlocksPanelLite: React.FC<IPullOutBlocksPanelLiteProps> = ({ blocks }) => (
  <PanelWrapper>
    <div className="pullOutBlocksPanelLite">
      {blocks.map((block: IBlock) => (
        <BlockCard
          key={block.title}
          onClick={() => {
            redirect(block.link?.url || "");
          }}
          buttonText={block.link?.text || ""}
          content={block.content!}
          image={block.image!}
          title={block.title}
        />
      ))}
    </div>
  </PanelWrapper>
);
